// src/pages/jobs/JobPostPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import JobCreationForm from '../../components/jobs/JobCreationForm';
import { ArrowLeft } from 'lucide-react';

const JobPostPage = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    // Navigate to job management after successful post
    setTimeout(() => {
      navigate('/jobs/manage');
    }, 2000);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Back Button */}
        <button
          onClick={handleCancel}
          className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6 transition-colors"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to Dashboard
        </button>

        {/* Job Creation Form */}
        <JobCreationForm 
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default JobPostPage;